<template>
   <div class="print_header_design_4" id="print_header_design_4">
      <div class="info" :class="$isArb() ? '': 'flex-row-reverse'">
         <div class="logo">
            <img :src="`${URL_PATH + UPLOADS_IMG_FOLDER_NAME}shop/${shopSecondImg}`" class="w-200px no-img-loader" alt="Shop Logo">
         </div>
         <!-- time & date  -->
         <div class="info-label">
            <span>{{ time }}</span> 
            <span>{{ date }}</span>
            <span class="fw-bold"><span class="text-danger">No.</span> {{ invoiceNumber }}</span>
         </div>

         <div class="address">
            <span>{{ shopAddress }}</span>
         </div>
      </div>

      <p class="desc">{{ titleMsg }}</p>

      <div class="logo-wrapper">
         <div class="logo">
            <img :src="`${URL_PATH + UPLOADS_IMG_FOLDER_NAME}shop/${shopImg}`" class="rounded-img-150 no-img-loader" alt="Shop Logo">
         </div>

         <div class="under-logo">
            <div class="social" v-if="shopFacebook || shopInstagram || shopTelegram || shopWhatsapp">
               <div class="social_row">
                  <div v-if="shopFacebook">
                     <i class="fa-brands fa-facebook"></i>
                     <span>{{ shopFacebook }}</span>
                  </div>
                  <div v-if="shopInstagram">
                     <i class="fa-brands fa-instagram"></i>
                     <span>{{ shopInstagram }}</span>
                  </div>
               </div>
               <div class="social_row">
                  <div v-if="shopWhatsapp">
                     <i class="fa-brands fa-whatsapp"></i>
                     <span>{{ shopWhatsapp }}</span>
                  </div>
                  <div v-if="shopTelegram">
                     <i class="fa-brands fa-telegram"></i>
                     <span>{{ shopTelegram }}</span>
                  </div>
               </div>
            </div>

            <div class="phone">
               <span>{{ shopPhone }}</span>
               <span>{{ shopSecondPhone }}</span>
            </div>
   
         </div>
      </div>
   </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n';

export default {
   props: {
      currency: String,
      invoiceNumber: {
         type: [String, Boolean],
         default: false,
      },
      title: {
         type: [String, Boolean],
         default: false,
      },
      date: {
         type: String,
         default: getDate(),
      },
      time: {
         type: String,
         default: getTime(),
      }
   },
   setup (props) {
      const store = useStore();
      const { t } = useI18n();
      const shop  = store.getters['shop/getShop'];


      const state = reactive({
         shopName: shop.name || false,
         shopImg: shop.image || false,
         shopSecondImg: shop.secondImage || false,
         shopPhone: shop.phone || false,
         shopSecondPhone: shop.secondPhone || '',
         shopAddress: shop.address || false,
         shopFacebook: shop.facebook || false,
         shopInstagram: shop.instagram || false,
         shopTelegram: shop.telegram || false,
         shopWhatsapp: shop.whatsapp || false,

         URL_PATH,
         UPLOADS_IMG_FOLDER_NAME,
      });

      const currencyName = computed(()=> {
         if (props.currency == 'dollar') return 'lang_in_dollar';
         else return 'lang_in_dinar';
      });

      const titleMsg = computed(()=> {
         if (props.title === false) return shop.description;
         else return t(props.title);
      });
   
      return {
         ...toRefs(state),

         currencyName,
         titleMsg,
      }
   }
}
</script>


<style lang="scss" scoped>
@use '@sass/helpers' as *;

.print_header_design_4 {
   position: relative;
   display: flex;
   justify-content: space-between;
   align-items: flex-start;
   margin-bottom: rem(20);
   min-height: rem(150);
   height: fit-content;
   border: solid 2px #555555;
   border-radius: rem(10);
   padding: rem(5);
   margin: 0.25rem;
   overflow: hidden;

   background-image: url('@/assets/imgs/shop_imgs/dotted-design.jpg');
   background-size: 300px;
   background-position: center;
   background-repeat: no-repeat;

   .info-label {
      margin-top: 1rem;
   }

   .desc {
      padding: rem(20) 0;
      align-self: flex-start;
      text-transform: capitalize;
      font-size: rem(25);
   }

   .wrapper-logo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: rem(5);
      font-size: rem(14);
      text-align: center;
   }
   
   .under-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: rem(15);
   }

   .logo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
   }

   .phone {
      display: flex;
      flex-direction: column;
      gap: rem(5);

      > * {
         letter-spacing: rem(2);
      }
   }

}
</style>